import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { 
  updateBalanceRecord,
  deleteBalanceRecord,
  fetchBalanceRecords
} from '../slices/employeeBalance';
import { fetchONeUser } from '../slices/user';
import { fetchUser } from '../slices/user';
export const useBalanceRecord = (userId) => {
  const dispatch = useDispatch();
  const { records: balanceRecords, loading, submitting } = useSelector(state => state.employeeBalance);
  const [editingRecord, setEditingRecord] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(null);
  const [originalBalance, setOriginalBalance] = useState(null);
  const [currentEditValue, setCurrentEditValue] = useState(null);

  const startEditing = (record) => {
    setEditingRecord(record._id);
    setOriginalBalance(record.balance);
    setCurrentEditValue(record.balance);
  };

  const cancelEditing = () => {
    setEditingRecord(null);
    setOriginalBalance(null);
    setCurrentEditValue(null);
  };

  const handleInputChange = (e) => {
    setCurrentEditValue(e.target.value);
  };

  const confirmDelete = (recordId) => {
    setRecordToDelete(recordId);
    setShowDeleteModal(true);
  };

  const handleDeleteRecord = async () => {
    try {
      await dispatch(deleteBalanceRecord(recordToDelete)).unwrap();
      toast.success("Balance record deleted successfully!");
      setShowDeleteModal(false);
      setRecordToDelete(null);
      dispatch(fetchBalanceRecords(userId));
      dispatch(fetchUser());
    } catch (error) {
      console.error("Error deleting record:", error);
      toast.error(error?.message || "Failed to delete balance record");
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setRecordToDelete(null);
  };

  const handleUpdateBalance = async (recordId, newBalance) => {
    if (parseFloat(newBalance) === parseFloat(originalBalance)) {
      setEditingRecord(null);
      return;
    }

    try {
      await dispatch(updateBalanceRecord({
        recordId,
        newBalance: parseFloat(newBalance)
      })).unwrap();
      toast.success("Balance updated successfully!");
      cancelEditing();
      dispatch(fetchBalanceRecords(userId));
      dispatch(fetchUser());

    } catch (error) {
      console.error("Error updating balance record:", error);
      toast.error(error?.message || "Failed to update balance");
    }
  };

  const isValueChanged = currentEditValue !== null && 
    parseFloat(currentEditValue) !== parseFloat(originalBalance);

  return {
    balanceRecords,
    loading,
    submitting,
    editingRecord,
    showDeleteModal,
    recordToDelete,
    isValueChanged,
    startEditing,
    cancelEditing,
    handleInputChange,
    confirmDelete,
    handleDeleteRecord,
    handleCancelDelete,
    handleUpdateBalance
  };
}; 